import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import ModalForm from "~components/organisms/modal/modal_form/modal_form";
import TOCIconButton from "../toc_icon_button/toc_icon_button";

function TOCDownloadModalController({
  downloadFormId,
  downloadFormTitle,
  downloadFormDescription,
  downloadButtonText,
  lang,
  isNavExpanded,
  isSmall,
  conversionType,
}) {
  const [isDownloadModalActive, setIsDownloadModalActive] = useState(false);

  const toggleModal = useCallback(() => {
    return setIsDownloadModalActive((currentState) => {
      return !currentState;
    });
  }, []);

  return (
    <>
      <TOCIconButton
        onClick={toggleModal}
        isNavExpanded={isNavExpanded}
        icon="icon_download"
        title={downloadButtonText}
        isSmall={isSmall}
        isReversed
      />
      <ModalForm
        formDescription={downloadFormDescription}
        formId={downloadFormId}
        formTitle={downloadFormTitle}
        isModalActive={isDownloadModalActive}
        lang={lang}
        setModalActiveState={setIsDownloadModalActive}
        conversionType={conversionType}
      />
    </>
  );
}

TOCDownloadModalController.propTypes = {
  downloadButtonText: PropTypes.string,
  downloadFormId: PropTypes.string,
  downloadFormDescription: PropTypes.string,
  downloadFormTitle: PropTypes.string,
  lang: PropTypes.string,
  isNavExpanded: PropTypes.bool,
  isSmall: PropTypes.bool,
  conversionType: PropTypes.string,
};

TOCDownloadModalController.defaultProps = {
  downloadButtonText: null,
  downloadFormDescription: null,
  downloadFormId: null,
  downloadFormTitle: null,
  lang: "en-gb",
  isNavExpanded: false,
  isSmall: false,
  conversionType: "primary_conversion",
};

export default TOCDownloadModalController;
